import langs from './modules/langs'
import auth from './modules/auth'

const modules = {
  langs,
  auth,
}

export default modules
